<div class="card-body">
    <canvas height="100px" id="bar_chart_with_line"></canvas>
</div>